
export const HOST = process.env.REACT_APP_API_BASE_URL;
export const SENTRY_SDK = process.env.REACT_APP_SENTRY_SDK;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT ? process.env.REACT_APP_ENVIRONMENT : "LOCAL";
export const APP_NAME = "/finalyze";
export const ROUTER = "/api";

